import { translate } from 'src/boot/i18n';
import usePlatformHelpers, {
  BROWSERS,
  DEVICE,
  PLATFORM,
} from 'src/composables/platformHelpers';

export interface IButtonData {
  icon: string;
  text: string;
  link: string;
}

export const STORE_LINKS = {
  ANDROID: 'https://play.google.com/store/apps/details?id=org.cheerie',
  IOS: 'https://apps.apple.com/app/id1573857405',
  CHROME:
    'https://chromewebstore.google.com/detail/cheerie-you-search-we-don/hhiffohlmhfhobhohllphmiamcbbmlkl',
  FIREFOX:
    'https://addons.mozilla.org/en-GB/firefox/addon/cheerie-you-search-we-donate/',
  SAFARI:
    'https://apps.apple.com/us/app/cheerie-search-save-animals/id1597085577',
  EDGE: 'https://microsoftedge.microsoft.com/addons/detail/cheerie-you-search-we-/ghdohfmnnkmjhmbbcfncickoafimbahf',
};

export default function useExtensionProps() {
  const { whichBrowser, whichDevice, whichPlatform } = usePlatformHelpers();

  const androidButtonData = {
    icon: 'android',
    text: translate('downloadFor', { platform: 'Android' }),
    link: STORE_LINKS.ANDROID,
  };

  const iosButtonData = {
    icon: 'ios',
    text: translate('downloadFor', { platform: 'IOS' }),
    link: STORE_LINKS.IOS,
  };

  const chromeButtonData = {
    icon: 'chrome',
    text: translate('addCheerieTo', { platform: 'Chrome' }),
    link: STORE_LINKS.CHROME,
  };

  const firefoxButtonData = {
    icon: 'firefox',
    text: translate('addCheerieTo', { platform: 'Firefox' }),
    link: STORE_LINKS.FIREFOX,
  };

  const safariButtonData = {
    icon: 'ios',
    text: translate('downloadFor', { platform: 'Mac' }),
    link: STORE_LINKS.SAFARI,
  };

  const edgeButtonData = {
    icon: 'edge',
    text: translate('addCheerieTo', { platform: 'Edge' }),
    link: STORE_LINKS.EDGE,
  };

  const defaultButtonData = {
    icon: 'facebook',
    text: translate('shareCheerie'),
    link: 'https://www.facebook.com/sharer/sharer.php?u=cheerie.org',
  };

  function buttonOptions(): IButtonData {
    const buttonDataMap: { [key: string]: IButtonData } = {
      [BROWSERS.CHROME]: chromeButtonData,
      [BROWSERS.EDGE]: edgeButtonData,
      [BROWSERS.FIREFOX]: firefoxButtonData,
      [BROWSERS.SAFARI]: safariButtonData,
      [BROWSERS.OTHER]: defaultButtonData,
      [BROWSERS.OPERA]: defaultButtonData,
      [PLATFORM.ANDROID]: androidButtonData,
      [PLATFORM.IOS]: iosButtonData,
      [PLATFORM.UNKNOWN]: defaultButtonData,
    };

    return whichDevice() === DEVICE.DESKTOP
      ? buttonDataMap[whichBrowser()]
      : buttonDataMap[whichPlatform()];
  }

  return {
    androidButtonData,
    iosButtonData,
    chromeButtonData,
    firefoxButtonData,
    safariButtonData,
    edgeButtonData,
    defaultButtonData,
    buttonOptions,
  };
}
